import React from 'react';
import { Check, ShieldCheck, CreditCard, Lock } from 'lucide-react';
export function PricingSection() {
  return <section id="oferta" className="py-5 sm:py-16 bg-[#0a1628] relative" data-id="element-105">
      <div className="max-w-3xl mx-auto px-3 sm:px-6" data-id="element-106">
        <div className="text-center mb-4 sm:mb-8" data-id="element-107">
          <h2 className="text-xl sm:text-4xl md:text-5xl font-black text-white uppercase tracking-tight" data-id="element-108">
            Oferta Especial
          </h2>
          <div className="h-0.5 sm:h-1 w-16 sm:w-20 bg-[#fbbf24] mx-auto mt-2 sm:mt-3 rounded-full" data-id="element-109"></div>
        </div>

        {/* MAIN OFFER BOX */}
        <div className="bg-white rounded-xl shadow-2xl overflow-hidden border-4 border-[#fbbf24] mb-5 sm:mb-12" data-id="element-110">
          <div className="bg-[#fbbf24] py-1.5 sm:py-3 text-center" data-id="element-111">
            <span className="text-[#0a1628] font-black text-xs sm:text-lg tracking-wider uppercase" data-id="element-112">
              ⭐ EL KIT MÁS VENDIDO ⭐
            </span>
          </div>

          <div className="p-3 sm:p-8 text-center" data-id="element-113">
            <h3 className="text-lg sm:text-3xl font-bold text-gray-900 mb-2 sm:mb-4" data-id="element-114">
              Kit Completo Tecnología Lista
            </h3>

            <div className="flex flex-col items-center justify-center mb-3 sm:mb-6" data-id="element-115">
              <span className="text-gray-400 text-sm sm:text-xl line-through font-medium mb-0" data-id="element-116">
                $47.900
              </span>
              <span className="text-[#16a34a] text-2xl sm:text-3xl md:text-4xl font-black tracking-tight" data-id="element-117">
                $19.990 ARS
              </span>
            </div>

            <div className="bg-gray-50 rounded-lg p-2.5 sm:p-5 mb-3 sm:mb-6 text-left max-w-sm mx-auto border border-gray-200" data-id="element-118">
              <p className="font-bold text-gray-700 mb-2 sm:mb-3 uppercase text-[10px] sm:text-xs tracking-wide text-center" data-id="element-119">
                Incluye todo esto:
              </p>
              <ul className="space-y-1.5 sm:space-y-2" data-id="element-120">
                {['Kit completo (7 materiales)', 'BONUS Planificación lista', 'BONUS Evaluaciones listas', 'Entrega por Drive (PDF)', 'Garantía 7 días'].map((item, i) => <li key={i} className="flex items-center text-gray-800 font-medium text-xs sm:text-sm" data-id="element-121">
                    <Check className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 mr-2 flex-shrink-0" strokeWidth={3} data-id="element-122" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="mb-3 sm:mb-5" data-id="element-123">
              <p className="text-[10px] sm:text-xs text-gray-500 mb-1 font-medium" data-id="element-124">
                Medios de pago:
              </p>
              <div className="flex items-center justify-center gap-1 text-gray-700 font-medium bg-gray-100 py-1.5 px-3 rounded-full text-[10px] sm:text-xs inline-flex" data-id="element-125">
                <CreditCard className="h-3 w-3 mr-1 flex-shrink-0" data-id="element-126" />
                <span data-id="element-127">Transferencia · Mercado Pago · Tarjeta</span>
              </div>
            </div>

            <a href="https://checkout.kitonline.shop/cart/47698138988782:1" className="block w-full bg-[#16a34a] hover:bg-green-700 text-white text-base sm:text-2xl font-black py-3.5 sm:py-4 px-4 rounded-lg shadow-[0_4px_0_rgb(21,128,61)] hover:shadow-[0_2px_0_rgb(21,128,61)] hover:translate-y-[2px] transition-all uppercase mb-2 sm:mb-3" data-id="element-128">
              COMPRAR AHORA →
            </a>

            <div className="flex items-center justify-center text-gray-500 text-[10px] sm:text-xs font-medium mb-2" data-id="element-129">
              <Lock className="h-3 w-3 mr-1" data-id="element-130" />
              PAGO SEGURO CON MERCADO PAGO
            </div>

            <p className="text-gray-500 text-[10px] sm:text-xs" data-id="element-131">
              Luego del pago, te enviamos el acceso por Drive.
            </p>
          </div>
        </div>

        {/* UPSELL BOX */}
        <div className="bg-[#1e293b] rounded-xl shadow-2xl overflow-hidden border border-gray-700 relative" data-id="element-132">
          <div className="absolute top-0 right-0 bg-[#dc2626] text-white text-[9px] sm:text-xs font-bold px-2 py-0.5 sm:py-1 rounded-bl-lg uppercase" data-id="element-133">
            Oferta Limitada
          </div>

          <div className="p-3 sm:p-6 md:p-8" data-id="element-134">
            <div className="flex flex-col md:flex-row gap-3 sm:gap-6 items-center" data-id="element-135">
              {/* Left Content */}
              <div className="flex-1 text-center md:text-left" data-id="element-136">
                <span className="inline-block bg-blue-600 text-white text-[9px] sm:text-xs font-bold px-2 py-0.5 rounded-full mb-2 uppercase tracking-wide" data-id="element-137">
                  Pack Profesional
                </span>
                <h3 className="text-lg sm:text-2xl font-bold text-white mb-1" data-id="element-138">
                  KIT COMPLETO + ROBÓTICA LISTA
                </h3>
                <p className="text-gray-400 mb-3 sm:mb-4 text-xs sm:text-sm" data-id="element-139">
                  Mega Pack completo + herramientas para producir obras
                </p>

                {/* Image between description and price */}
                <div className="mb-3 sm:mb-4" data-id="element-140">
                  <a href="https://checkout.kitonline.shop/cart/47698140299502:1" className="block hover:opacity-90 transition-opacity" data-id="element-141">
                    <img src="https://cdn.magicpatterns.com/uploads/pe2y67cqXq2U2DwkEZe1mj/UPSELL_TECNOLOGIA.png" alt="Pack Profesional Robótica" className="w-full h-auto rounded-lg shadow-lg" data-id="element-142" />
                  </a>
                </div>

                <div className="flex items-baseline justify-center md:justify-start gap-2 sm:gap-3 mb-3 sm:mb-4" data-id="element-143">
                  <span className="text-gray-500 text-sm sm:text-lg line-through" data-id="element-144">
                    $69.990
                  </span>
                  <span className="text-[#fbbf24] text-2xl sm:text-3xl font-bold" data-id="element-145">
                    $27.990
                  </span>
                </div>

                <a href="https://checkout.kitonline.shop/cart/47698140299502:1" className="block w-full bg-[#16a34a] hover:bg-green-700 text-white text-sm sm:text-lg font-bold py-2.5 sm:py-3 px-4 rounded-lg shadow-lg transition-colors text-center mb-2" data-id="element-146">
                  SÍ, QUIERO LA OFERTA →
                </a>

                <div className="flex items-center justify-center md:justify-start text-gray-400 text-[9px] sm:text-xs font-medium" data-id="element-147">
                  <ShieldCheck className="h-3 w-3 mr-1" data-id="element-148" />
                  Pago seguro con Mercado Pago
                </div>
              </div>

              {/* Right Content - Features list */}
              <div className="flex-1 w-full" data-id="element-149">
                <ul className="space-y-1 sm:space-y-1.5 text-[10px] sm:text-xs text-gray-300" data-id="element-150">
                  {['Proyectos de robótica listos para aplicar', 'Guías paso a paso con programación', 'Actividades prácticas alineadas a STEM', 'Rúbricas e instrumentos de evaluación', 'Propuestas con automatización', 'Ideal para primaria y secundaria'].map((item, i) => <li key={i} className="flex items-start" data-id="element-151">
                      <div className="min-w-[4px] h-[4px] rounded-full bg-[#fbbf24] mt-1 mr-1.5" data-id="element-152"></div>
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}